import Modal from "../../widgets/modal/modal.vue";
import Tree from "../../widgets/tree/tree.vue";
import { Helper } from '../../../assets/ts/global';
import BaseComboBox from './BaseComboBox.vue';
import Loading from '../../widgets/loading/loading.vue';

const helper = new Helper();

export default {
    props: [
        'showDelegationModal',
        'modalData'
    ],
    data() {
        return {
            modalHeader: "",
            direction: payload.currentLocale.IsRightToLeft,
            dataTree: [],
            treeTemp: null,
            checkedNodes: [],
            comboBoxData: {},
            destnationId: null,
            isPermanent: false,
            comboValue: null,
            items: [],
            disabledCombo: false,
            errors: [],
            fromDate: null,
            toDate: null
        }
    },
    computed: {
        showModal() {
            this.init();

            this.modalHeader = this.modalData.isCreation ? i18n.$t("delegation_management.delegation_add") :
                i18n.$t("delegation_management.delegation_edit");

            if (!this.modalData.isCreation) {
                this.edit();
                return this.showDelegationModal;
            } else {
                return this.showDelegationModal;
            }
        }
    },
    methods: {
        changeIsPermanent() {
            if (!this.isPermanent) {
                this.toDate.val('');
                this.fromDate.val('');
            }
        },
        init() {
            this.fromDate = $("#fromDate");
            this.toDate = $("#toDate");
            this.toDate.val('');
            this.fromDate.val('');
            this.comboValue = null;
            this.checkedNodes = [];
            this.items = [];
            this.isPermanent = false;
            this.destnationId = null;
            this.disabledCombo = false;
            this.errors = [];
        },
        ddlUsers(value) {
            this.comboValue = value;
            this.destnationId = value.id;
        },
        checkedNodeIds(nodes) {
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked) {
                    this.checkedNodes.push({
                        id: nodes[i].id,
                        itemType: nodes[i].ItemType
                    });
                }

                if (nodes[i].hasChildren) {
                    this.checkedNodeIds(nodes[i].children.view());
                }
            }
        },
        nodeCheck(nodes) {
            this.checkedNodes = [];

            this.checkedNodeIds(nodes);
        },
        validation() {
            var result = true;

            if (this.destnationId === null) {
                this.errors.push(i18n.$t("delegation_management.messages.select_user"));
                result = false;
            }

            if (!this.checkedNodes.length) {
                this.errors.push(i18n.$t("delegation_management.messages.select_folder"));
                result = false;
            }

            if (!this.isPermanent && (this.fromDate.val() === '' || this.toDate.val() === '')) {
                this.errors.push(i18n.$t("delegation_management.messages.select_date"));
                result = false;
            } else if (!this.isPermanent) {
                var fromDate = this.fromDate.MdPersianDateTimePicker('getDate');
                var toDate = this.toDate.MdPersianDateTimePicker('getDate');

                if (fromDate > toDate) {
                    this.errors.push(i18n.$t("delegation_management.messages.compare_fromDate_toDate"));
                    result = false;
                }
            }

            return result;

        },
        submit() {
            this.errors = [];
            if (this.validation()) {

                let url = "api/delegations/save";
                let data = {};
                let callback;

                data = {
                    destinationId: this.destnationId,
                    fromDate: this.fromDate.val(),
                    toDate: this.toDate.val(),
                    isPermanent: this.isPermanent,
                    delegationsTree: this.checkedNodes
                };

                callback = (result) => {
                    $('.cancelModal', this.$el).click();
                    this.modalData.callback();
                };

                var that = this;

                this.doAjaxRequest(url,
                    JSON.stringify(data),
                    callback,
                    function (data) {
                        console.log(data);
                        for (var i = 0; i < data.length; i++) {
                            var item = data[i];
                            for (var j = 0; j < item.Errors.length; j++) {
                                var errorItem = item.Errors[j];
                                that.errors.push(i18n.$t(errorItem.ErrorMessage));
                            }
                        }
                    },
                    'POST');

            }
        },
        doAjaxRequest(url, data, onSuccess, onFailure, method) {
            let ajaxConfig = {
                url: url,
                data: data,
                dataType: "json",

                contentType: "application/json;charset=utf-8"
            };
            ajaxConfig.beforeSend = (xhr) => {
                xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
            };
            if (method) {
                ajaxConfig.method = method;
            }
            $.ajax(ajaxConfig)
                .done((result) => {
                    if (typeof onSuccess === 'function')
                        onSuccess(result);
                }).error((error) => {
                    if (typeof onFailure === 'function') {

                        var response = null;

                        if (error.status == 400) {
                            response = JSON.parse(error.responseText);
                            onFailure(response);
                        }
                    }
                });
        },
        edit() {
            var that = this;

            var id = this.modalData.id;

            this.comboValue = { id: id, label: this.modalData.label };
            this.disabledCombo = true;
            this.destnationId = id;

            var url = "api/delegations/get/" + id;

            this.doAjaxRequest(
                url, {},
                (data) => {
                    var array = [];

                    data.DelegationsTree.forEach(function (node) {

                        array.push(node.Id);

                        that.checkedNodes.push({
                            id: node.Id,
                            itemType: 4
                        });

                    });

                    that.items = array;
                    that.fromDate.val(data.FromDate);
                    that.toDate.val(data.ToDate);
                    that.isPermanent = data.IsPermanent;
                });
        }
    },
    updated() {
    },
    mounted() {

        var baseInfo = this.modalData.baseInfo;

        this.dataTree = baseInfo.tree;
        this.treeTemp = $("#rayvarzBPMSKendoTreeViewTemplate", this.$el).html();

        this.comboBoxData.results = baseInfo.users;

        this.fromDate = $("#fromDate");
        this.toDate = $("#toDate");

        this.fromDate.click(function (e) {
            e.stopPropagation();
        });

        this.toDate.click(function (e) {
            e.stopPropagation();
        });

        this.fromDate.MdPersianDateTimePicker({
            Placement: 'bottom',
            Trigger: 'click',
            EnableTimePicker: false,
            TargetSelector: '#fromDate',
            Format: 'yyyy/MM/dd',
            IsGregorian: payload.currentLocale.Culture !== 'fa-IR',
            EnglishNumber: true,
        });

        this.toDate.MdPersianDateTimePicker({
            Placement: 'bottom',
            Trigger: 'click',
            EnableTimePicker: false,
            TargetSelector: '#toDate',
            Format: 'yyyy/MM/dd',
            IsGregorian: payload.currentLocale.Culture !== 'fa-IR',
            EnglishNumber: true,
        });
    },
    created() {
    },
    components: {
        Modal,
        Tree,
        BaseComboBox,
        Loading
    }
}
